export const GRID_DEFAULTS = {
    COLUMNS: 4,
    ROWS: 4,
    ROW_HEIGHT: 17,
    GAP: 16,
    MAX_SEARCH_ROWS: 100,
    MIN_WIDGET_SIZE: 1
} as const;

export const MAX_WIDGETS = 20;

export const RESIZE_DIRECTIONS = {
    SOUTHEAST: 'se',
    SOUTHWEST: 'sw',
    NORTHEAST: 'ne',
    NORTHWEST: 'nw'
} as const;

export type ResizeDirection = typeof RESIZE_DIRECTIONS[keyof typeof RESIZE_DIRECTIONS];

export const RESIZE_MULTIPLIERS: Record<ResizeDirection, { width: number; height: number; x: number; y: number }> = {
    [RESIZE_DIRECTIONS.SOUTHEAST]: { width: 1, height: 1, x: 0, y: 0 },
    [RESIZE_DIRECTIONS.SOUTHWEST]: { width: -1, height: 1, x: 1, y: 0 },
    [RESIZE_DIRECTIONS.NORTHEAST]: { width: 1, height: -1, x: 0, y: 1 },
    [RESIZE_DIRECTIONS.NORTHWEST]: { width: -1, height: -1, x: 1, y: 1 }
};

export const SETTINGS_TABS = {
    WIDGETS: 'widgets',
    LAYOUT: 'layout',
    PROPERTIES: 'properties'
} as const;

export type SettingsTab = typeof SETTINGS_TABS[keyof typeof SETTINGS_TABS];

export const WIDGET_TYPES = {
    STATISTICS_CARD: 'statistics-card',
    RECENT_ITEMS_LIST: 'recent-items-list',
    QUICK_ACTIONS: 'quick-actions',
    SAMPLE_STATUS_CHART: 'sample-status-chart'
} as const;

export type WidgetType = typeof WIDGET_TYPES[keyof typeof WIDGET_TYPES];

export const COLUMN_OPTIONS = [
    { value: 2, label: '2 Columns' },
    { value: 3, label: '3 Columns' },
    { value: 4, label: '4 Columns' },
    { value: 5, label: '5 Columns' },
    { value: 6, label: '6 Columns' },
    { value: 7, label: '7 Columns' },
    { value: 8, label: '8 Columns' }
] as const;

export const ROW_HEIGHT_PRESETS = [
    { key: 'xs', label: 'Extra Small', value: 10 },
    { key: 'compact', label: 'Compact', value: 13 },
    { key: 'small', label: 'Small', value: 15 },
    { key: 'normal', label: 'Normal', value: 17 },
    { key: 'large', label: 'Large', value: 22 },
    { key: 'xl', label: 'Extra Large', value: 28 }
] as const;

export const GAP_PRESETS = [
    { key: 'none', label: 'None', value: 0 },
    { key: 'xs', label: 'Extra Small', value: 4 },
    { key: 'small', label: 'Small', value: 8 },
    { key: 'medium', label: 'Medium', value: 16 },
    { key: 'large', label: 'Large', value: 24 },
    { key: 'xl', label: 'Extra Large', value: 32 }
] as const;

export const CSS_SELECTORS = {
    DASHBOARD_GRID: '.dashboard-grid'
} as const;